if (!customElements.get('sl-home')) {
  class SLHome extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.reduce = matchMedia('(prefers-reduced-motion: reduce)');
      const signal = this.controller.signal;
      this.index = 0;
      this.paused = this.reduce.matches;
      this.dataset.paused = String(this.paused);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.dataset.visible = String(this.visible);
        this.schedule();
        if (this.dataset.layout === 'guarantee' && this.visible && !this.reduce.matches && !this.played) this.flip();
      }, {threshold:.12});
      this.observer.observe(this);
      if (this.dataset.layout === 'carousel') {
        this.tabs = [...this.querySelectorAll('[data-tab]')];
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.messages = [...this.querySelectorAll('[data-flavor-copy]')];
        this.tabs.forEach((tab, i) => {
          tab.id = `${this.closest('.shopify-section').id}-tab-${i}`;
          this.slides[i].id = `${this.closest('.shopify-section').id}-slide-${i}`;
          tab.setAttribute('aria-controls', this.slides[i].id);
          this.slides[i].setAttribute('role','tabpanel');
          this.slides[i].setAttribute('aria-labelledby', tab.id);
          tab.addEventListener('click', () => { this.select(i); this.setPaused(true); }, {signal});
          tab.addEventListener('keydown', e => {
            if (!['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) return;
            e.preventDefault();
            const next = e.key === 'Home' ? 0 : e.key === 'End' ? 2 : (i + (e.key === 'ArrowRight' ? 1 : 2)) % 3;
            this.select(next); this.setPaused(true); this.tabs[next].focus();
          }, {signal});
        });
        this.pauseButton = this.querySelector('[data-pause]');
        this.pauseButton.addEventListener('click', () => this.setPaused(!this.paused), {signal});
        this.addEventListener('pointerenter', () => { this.hovered = true; this.schedule(); }, {signal});
        this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, {signal});
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, {signal});
        this.addEventListener('focusout', () => { this.focused = false; this.schedule(); }, {signal});
        this.select(0);
        this.setPaused(this.paused);
      }
      if (this.dataset.layout === 'sticky') {
        this.target = document.getElementById('sl-home-products')?.closest('.shopify-section');
        this.sticky = this.querySelector('[data-home-sticky]');
        this.onScroll = () => { cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(() => {
          if (!this.target) return;
          const rect = this.target.getBoundingClientRect();
          const open = document.querySelector('dialog[open],cart-drawer-component[open]');
          this.sticky.hidden = !!open || scrollY < innerHeight * .8 || (rect.top < innerHeight && rect.bottom > 120);
        }); };
        window.addEventListener('scroll', this.onScroll, {passive:true,signal});
        this.modalObserver = new MutationObserver(this.onScroll);
        this.modalObserver.observe(document.body, {subtree:true,attributes:true,attributeFilter:['open']});
        this.onScroll();
      }
      this.reduce.addEventListener('change', () => { if (this.reduce.matches) { this.setPaused(true); this.calendarAnimation?.cancel(); } }, {signal});
      document.addEventListener('visibilitychange', () => this.schedule(), {signal});
    }
    select(i) {
      this.index = i;
      this.querySelector('.sl-home-carousel').dataset.flavor = ['mint','berry','strawberry'][i];
      this.tabs.forEach((tab, j) => { tab.setAttribute('aria-selected', String(i === j)); tab.tabIndex = i === j ? 0 : -1; });
      this.slides.forEach((slide, j) => { slide.classList.toggle('is-active',i === j); slide.inert = i !== j; slide.setAttribute('aria-hidden',String(i !== j)); });
      this.messages.forEach((message, j) => { message.classList.toggle('is-active',i === j); message.inert = i !== j; message.setAttribute('aria-hidden',String(i !== j)); });
      this.querySelector('[data-gummy-link]').href = this.slides[i === 2 ? 2 : 1].href;
    }
    setPaused(value) {
      this.paused = value; this.dataset.paused = String(value);
      if (this.pauseButton) { const text = value ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel; this.pauseButton.textContent = text; this.pauseButton.setAttribute('aria-label',text); }
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.dataset.layout !== 'carousel' || !this.visible || this.paused || this.hovered || this.focused || document.hidden || this.reduce.matches) return;
      this.timer = setTimeout(() => { this.select((this.index + 1) % 3); this.schedule(); },6500);
    }
    flip() {
      this.played = true;
      this.calendarAnimation = this.querySelector('[data-calendar-reel]').animate([{transform:'translateY(0)'},{transform:'translateY(calc(-29 * 160px))'}], {duration:1900,easing:'cubic-bezier(.2,.7,.2,1)',delay:200});
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; this.observer?.disconnect(); this.modalObserver?.disconnect(); this.calendarAnimation?.cancel(); clearTimeout(this.timer); cancelAnimationFrame(this.frame); }
  }
  customElements.define('sl-home',SLHome);
}
